import parse from "html-react-parser"
import PropTypes from "prop-types"
import styled from "styled-components"

const StringWithHighlights = styled.span`
  span {
    font-weight: 700;
  }
`

const HighlightedString = ({ highlightedString, originalString }) => {
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
  const escapedHighlightedString = highlightedString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&", "\\$&")
  const highlightRegex = new RegExp(escapedHighlightedString, "ig")

  return (
    <StringWithHighlights>
      {highlightedString && originalString
        ? parse(originalString.replace(highlightRegex, "<span>$&</span>"))
        : originalString
        ? parse(originalString)
        : ""}
    </StringWithHighlights>
  )
}

export default HighlightedString

HighlightedString.propTypes = {
  originalString: PropTypes.string,
  highlightedString: PropTypes.string,
}
